/** Sorts whose natural order is ascending (rank, calendar, alphabetical); the rest are newest first. Mirrors the API. */
const ASCENDING_BY_DEFAULT = new Set(['priority', 'dueDate', 'startDate', 'title', 'phase', 'status', 'type', 'assignee', 'author', 'project']);

export type SortDir = 'asc' | 'desc';

export function effectiveDir(sort: string, dir: string | null | undefined): SortDir {
  if (dir === 'asc' || dir === 'desc') return dir;
  return ASCENDING_BY_DEFAULT.has(sort) ? 'asc' : 'desc';
}

/**
 * Clicking a column header: a new column starts in its natural direction; clicking the active
 * column flips it. Returns URL values (null drops the parameter so URLs stay short).
 */
export function nextSort(currentSort: string, currentDir: string | null | undefined, clicked: string, defaultSort = 'updatedAt'): { sort: string | null; dir: SortDir | null } {
  if (clicked !== currentSort) return { sort: clicked === defaultSort ? null : clicked, dir: null };
  const natural = effectiveDir(clicked, null);
  const flipped: SortDir = effectiveDir(clicked, currentDir) === 'asc' ? 'desc' : 'asc';
  return { sort: clicked === defaultSort ? null : clicked, dir: flipped === natural ? null : flipped };
}

/** Values of a comma-separated URL parameter. */
export function listParam(params: URLSearchParams, key: string): string[] {
  return (params.get(key) ?? '').split(',').map((v) => v.trim()).filter(Boolean);
}

/** The parameter value after toggling one entry, or null when it becomes empty. */
export function toggleListValue(params: URLSearchParams, key: string, value: string): string | null {
  const current = new Set(listParam(params, key));
  if (current.has(value)) current.delete(value);
  else current.add(value);
  return [...current].join(',') || null;
}
